import { format } from 'url';
import { PreloadJob } from '../../UnicronApp/preloader/PreloadJob';
import { asDynamic } from '../util/Dynamic';
import { asRecord } from '../util/asRecord';
import { returnVoid } from '../util/returnVoid';
import { OpaqueUrl } from './util';

const TEMPORARY_REDIRECT = 302;
const PERMANENT_REDIRECT = 301;

export const preloadRedirect = (
  { server, services }: PreloadJob,
  url: OpaqueUrl,
  permanent?: boolean,
) => {
  const { browser, logger } = services;
  const { window } = browser;
  const urlString = format(url);

  if (server) {
    const { res } = server;

    try {
      res.writeHead(permanent ? PERMANENT_REDIRECT : TEMPORARY_REDIRECT, { Location: urlString });

      /** The framework will try to write its own header later, and will throw errors.
       * We turn the `writeHead` method into a no-op so it will happily ignore that we
       * have already returned a response.
       */
      asRecord(res).writeHead = returnVoid;
      res.end();
    } catch (error) {
      logger.error(`Failed to redirect: ${error}`, { cause: asDynamic(error) });
    }
  } else if (window) {
    window.location.replace(urlString);
  }
};
